import { render, staticRenderFns } from "./NetGsmChannelDetail.vue?vue&type=template&id=7617d409&scoped=true"
import script from "./NetGsmChannelDetail.vue?vue&type=script&lang=js"
export * from "./NetGsmChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./NetGsmChannelDetail.vue?vue&type=style&index=0&id=7617d409&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7617d409",
  null
  
)

export default component.exports